<!-- <template>
    <div class="ma-2 pa-2">
    </div>
</template> -->

<template>
    <v-card class="mx-auto" width="80%">
        <v-img
            class="align-end text-white"
            height="80%"
            src="/firelooks_banner.png"
            cover
        ></v-img>

        <!-- <v-card-subtitle class="pt-4"> Number 10 </v-card-subtitle> -->

        <v-card-text>
            <!-- <div>Whitehaven Beach</div>
            <div>Whitsunday Island, Whitsunday Islands</div> -->
            <v-card-title>Hello, we are Firelooks, a company specializing in fire safety </v-card-title>
        </v-card-text>

        <v-card-actions>
            <v-btn color="blue" text="User Agreement" onclick=""></v-btn>
            <v-btn color="blue" text="Private Policy"></v-btn>
        </v-card-actions>
    </v-card>
</template>

<script setup>
import { onMounted, onUpdated } from "vue";
import {
    faLog,
    // classBindsServiceAgreement,
    // styleBindsServiceAgreement,
} from "../common/faCommon.js";

// const cbsa = classBindsServiceAgreement;
// const sbsa = styleBindsServiceAgreement;

onUpdated(() => {
    faLog(0, "[MainPage] [onUpdated]");
});

onMounted(() => {
    faLog(0, "[MainPage] [onMounted]");
});
</script>
